import {Stack, Typography} from "@mui/material";
import * as React from "react";
import {useNavigate} from "react-router-dom";

const AccountUserCard = (props) =>
{
    const navigate = useNavigate();

    function onView()
    {
        navigate("../account/users/" + props.entry.userUID);
    }

    return (
        <Stack direction="column" padding={1} spacing={1} alignItems="center" backgroundColor={'#141C21'} onClick={onView} borderRadius={3} sx={{width: 200, height: 200, cursor: "pointer"}}>
            <img src="/icons/account_user_registration.png" width={64} height={64}/>
            <Stack direction="column" padding={1} alignItems="flex-start">
                <Typography>{props.entry.username}</Typography>
                <Typography variant="caption">{props.entry.display}</Typography>
                <Typography variant="caption">{props.entry.emailAddress}</Typography>
                <Typography variant="caption">{props.entry.phoneNumber}</Typography>
            </Stack>
        </Stack>
    )
}
export default AccountUserCard;
